import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import {
  getOrderDetails,
  trackOrder,
  postReorder,
  getInvoice,
} from 'hb-redux-store/feature/accounts/accounts.action';
import { isObjectEmpty } from 'hb-redux-store/util/miscellaneousServices';

import Button from 'components/common/Button/Button';
import Loader from 'components/mweb/Skeletons/Loader/Loader';
import { Link } from 'react-router-dom';
import Icon from 'components/mweb/Icon/Icon';
import {
  ORDER_TRACKING_STATUS,
  ORDER_STATUS_TO_POLL,
  RUPEE_SYMBOL,
} from 'hb-redux-store/util/constantServices';
import Messages from '../../mweb/Messages/Messages';
import MembershipOrderItem from 'components/mweb/HalalboxPrime/MembershipOrderItem';

class OrderDetails extends React.Component {
  state = { currentTrackingShipment: 0 };
  componentDidMount() {
    const { orderNo } = this.props.match ? this.props.match.params : this.props;
    this.props.getOrderDetails({ orderNo });
  }
  trackingPromise = null;
  componentWillUnmount() {
    clearInterval(this.trackingPromise);
    this.trackingPromise = null;
  }
  getStatusState = index => {
    let activeIndex = 0;
    const updatedActiveIndex = ORDER_TRACKING_STATUS.find(
      s => s.key === this.props.orderDetails?.status
    )?.position;
    if (updatedActiveIndex) activeIndex = updatedActiveIndex;
    if (index < activeIndex) return 'done';
    if (index === activeIndex) return 'active';
    if (index > activeIndex) return 'inactive';
  };

  trackOrder = (orderNo, index) => {
    if (this.trackingPromise) {
      clearInterval(this.trackingPromise);
      this.trackingPromise = null;
    }
    this.setState({ currentTrackingShipment: index }, () =>
      this.props.trackOrder({ orderNo })
    );
  };

  checkAndSetStatusPolling = () => {
    if (!this.trackingPromise) {
      this.trackingPromise = setInterval(() => {
        this.props.trackOrder({ orderNo: this.props.orderStatus.orderNo });
      }, 10000);
    }
  };

  getOrderStatusPill = () => {
    const {
      orderStatus: { status },
      orderDetails,
    } = this.props;
    const {
      isOrderCancelled,
      isOrderReturned,
      isOrderRefunded,
      isOrderReplaced,
      orderCancelledText = 'Order Cancelled',
      orderReturnedText = 'Order Returned',
      orderRefundedText = 'Refunded',
      orderReplacedText = 'Replaced',
    } = orderDetails?.shipmentSet[this.state.currentTrackingShipment] || {};
    const arrival =
      orderDetails?.shipmentSet[this.state.currentTrackingShipment]?.arrivalBy;
    if (arrival && status.length) {
      const os = status.find(s => s?.currentState === 'present');
      if (ORDER_STATUS_TO_POLL.indexOf(os?.hbOrderTrackingStatus) > -1) {
        this.checkAndSetStatusPolling();
      }
      return (
        <div className="pill arrival-pill">
          <Icon class="icon-status-arrival" size={15} />
          <span>{arrival}</span>
        </div>
      );
    }
    let displayStatus = orderDetails.status;
    if (status?.length) {
      const os = status.find(s => s?.currentState === 'present');

      // const os = ORDER_TRACKING_STATUS.find(
      //   s => s.key === currentState?.hbOrderTrackingStatus
      // );
      if (os) {
        if (ORDER_STATUS_TO_POLL.indexOf(os?.hbOrderTrackingStatus) > -1) {
          this.checkAndSetStatusPolling();
          return <div className="pill processing-pill">{os?.description}</div>;
        }
        if (os.key === 'ORDER_LOGISTICS_DELIVERED') {
          return <div className="pill delivered-pill">{os?.description}</div>;
        }
      }
    }
    if (isOrderCancelled) {
      return (
        <div className="pill error-pill">
          <Icon class="icon-status-order-cancelled" size={15} />
          <span>{orderCancelledText}</span>
        </div>
      );
    }
    if (isOrderRefunded) {
      return (
        <div className="pill delivered-pill">
          <Icon class="icon-status-order-refunded" size={15} />
          <span>{orderRefundedText}</span>
        </div>
      );
    }
    if (isOrderReturned) {
      return (
        <div className="pill delivered-pill">
          <Icon class="icon-status-order-returned" size={15} />
          <span>{orderReturnedText}</span>
        </div>
      );
    }
    if (isOrderReplaced) {
      return (
        <div className="pill delivered-pill">
          <span>{orderReplacedText}</span>
        </div>
      );
    }
    return <div className="pill error-pill">{displayStatus}</div>;
  };

  getInvoice = orderNo => {
    const payload = {
      orderNo,
      successCb: data => {
        const openPrintDialogue = () => {
          const mywindow = window.open(
            '',
            'print-invoice',
            'height=400,width=600'
          );
          mywindow.document.write(
            `<html><head><title>Invoice #${orderNo}</title>`
          );
          // mywindow.document.write(
          //   `<style type="text/css" >${INVOICE_PRINT_STYLE}</style>`
          // );
          mywindow.document.write('</head><body >');
          mywindow.document.write(data.invoiceBody);
          mywindow.document.write('</body></html>');
          mywindow.document.close();
          mywindow.focus();
          mywindow.print();
        };
        setTimeout(openPrintDialogue, 100);
      },
    };
    this.props.getInvoice(payload);
  };

  getOrderTracking = () => {
    const { orderStatus } = this.props;
    return orderStatus?.status?.map((status, index, statusArray) => {
      let state = 'done';
      if (status.currentState === 'present') state = 'active';
      if (status.currentState === 'future') state = 'inactive';
      return (
        <div className={`order-track ${state}`} key={index}>
          <div className="order-track--icon">
            <Icon src={status.iconUrl} size={30} />
          </div>
          <div className="order-track--timeline">
            <Icon
              class={`icon-status-order-${state} flex-shrink-0`}
              size={15}
            />
            {index !== statusArray.length - 1 && (
              <div className="order-track--timeline--border" />
            )}
          </div>
          <div className="order-track--message">
            <div className="justify-content--space-between">
              <div>{status.description}</div>
              {status.driverPhoneNo && status.showCallIcon && (
                <a
                  href={`tel:${status.driverPhoneNo}`}
                  target="_blank"
                  className="order-track--message--call-delivery-boy"
                >
                  <span>&nbsp;Call Delivery boy</span>
                  <Icon class="icon-status-call-green" size={18} />
                </a>
              )}
            </div>
            <div className="order-track--message--time">
              {status.orderTrackingStatusTime}
            </div>
          </div>
        </div>
      );
    });
  };

  render() {
    const { orderDetails, orderStatus, loading, launchInfo } = this.props;
    const { isSubscriptionActive = false } = launchInfo;
    const {
      paid,
      paymentLink,
      paymentMode,
      delivered,
      orderDate,
      refundAmountMsg,
      allowContactCCA,
      CCAContact,
      CCAContactText,
      summaryOrder = [],
      membershipDetails = {},
      status,
    } = orderDetails || {};
    let { podPaymentMethod = '', orderPaymentType = '' } = orderDetails || {};
    if (podPaymentMethod.toLowerCase() === 'hbw') podPaymentMethod = 'HBM';
    orderPaymentType =
      orderPaymentType.toLowerCase() === 'hbw'
        ? 'HBM'
        : orderPaymentType.toUpperCase();
    const { isSubscription } =
      orderDetails?.shipmentSet[this.state.currentTrackingShipment] || {};
    const showMembershipDetails = isObjectEmpty(membershipDetails);
    return (
      <div className="desktop-order-details">
        {loading && <Loader />}
        {!loading && orderDetails && (
          <React.Fragment>
            {isSubscriptionActive && (
              <div className="desktop-order-details--subscription">
                <Link to="/ramadan-subscription">
                  <img
                    src="https://ik.imagekit.io/iwcam3r8ka/prod/subscription/202103/00c75ac7-02f0-4335-bf1d-741e4acbb6dd.png"
                    alt="know more about ramadan"
                  />
                </Link>
              </div>
            )}
            <div className="desktop-order-details--highlights">
              {/* <div className="justify-content--space-between"> */}
              <div>
                <div className="desktop-order-details--highlights--row">
                  <span className="desktop-order-details--highlights--row--key">
                    Order No:
                  </span>
                  <span className="desktop-order-details--highlights--row--value">
                    {orderDetails.orderNo}
                  </span>
                </div>
                <div className="desktop-order-details--highlights--row">
                  <span className="desktop-order-details--highlights--row--key">
                    {delivered ? 'Order delivered on:' : 'Order placed on:'}
                  </span>
                  <span className="desktop-order-details--highlights--row--value">
                    {orderDate}
                  </span>
                </div>
                <div className="desktop-order-details--highlights--row">
                  <span className="desktop-order-details--highlights--row--key">
                    {paid ? 'Amount Paid:' : 'Amount to be Paid:'}
                  </span>
                  <span className="desktop-order-details--highlights--row--value">
                    <div>
                      &#8377;{orderDetails?.priceDetails?.orderPayableAmount}
                    </div>
                  </span>
                </div>
                <div className="desktop-order-details--highlights--row">
                  {isSubscription && (
                    <div className="desktop-order-details--highlights--subscription">
                      <Icon class="icon-app-bar-subscription" size={28} />
                      <div className="subscription-tag">
                        Ramadan Subscription
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {(orderDetails?.viewInvoice || delivered) && (
                <Fragment>
                  <div className="desktop-order-card--divider"></div>
                  <div className="justify-content--space-between desktop-order-details--right-container">
                    {orderDetails?.viewInvoice && (
                      <Link
                        className="desktop-order-details--highlights--invoice button action-link more"
                        to="#"
                        onClick={() => this.getInvoice(orderDetails.orderNo)}
                      >
                        View Invoice
                      </Link>
                    )}
                    {delivered && (
                      <div>
                        <Button
                          className="button button-ghost"
                          onClick={() =>
                            this.props.postReorder(orderDetails.orderNo)
                          }
                        >
                          REORDER
                        </Button>
                      </div>
                    )}
                  </div>
                </Fragment>
              )}
              {paymentMode === 'POD' && paymentLink && !paid && (
                <React.Fragment>
                  <div className="desktop-order-card--divider" />
                  <div className="desktop-order-card--pending-message-container">
                    <div className="desktop-order-card--message-container">
                      <Icon class="icon-common-red-exclamation" size={20} />
                      <span class="desktop-order-card--pending-text">
                        Payment Pending of {RUPEE_SYMBOL}
                        {orderDetails?.priceDetails?.orderPayableAmount}
                      </span>
                    </div>
                    {paymentLink && (
                      <div>
                        <a
                          href={paymentLink}
                          className="button button-primary desktop-order-card--button-size"
                        >
                          Pay Now
                        </a>
                      </div>
                    )}
                  </div>
                </React.Fragment>
              )}
            </div>
            <div className="section-divider"></div>
            {status && (
              <div>
                <div className="justify-content--space-between">
                  <div className="desktop-order-details--status-title">
                    ORDER STATUS
                  </div>
                  <div className="desktop-order-details--status-pill">
                    {this.getOrderStatusPill()}
                  </div>
                </div>
                <div>
                  {orderStatus?.status?.length > 0 && (
                    <div className="desktop-order-details--status">
                      {orderDetails.shipmentSet.length > 1 && (
                        <div className="pill shipment-pill">
                          <Icon
                            class="icon-order-shipment-box pill--icon"
                            size={18}
                          />
                          Shipment {this.state.currentTrackingShipment + 1}
                        </div>
                      )}
                      {orderStatus?.status?.length > 0 &&
                        this.getOrderTracking()}
                    </div>
                  )}
                </div>
              </div>
            )}
            <div className="desktop-order-details--items">
              <div className="desktop-order-details--items--title">
                ORDERED ITEMS
              </div>
              <div className="desktop-order-details--shipments">
                {orderDetails.shipmentSet.map((shipment, index) => {
                  return (
                    <React.Fragment key={shipment.orderNo}>
                      {orderDetails.shipmentSet.length > 1 && (
                        <div className="desktop-order-details--shipments--shipment-no justify-content--space-between">
                          <div className="pill shipment-pill">
                            <Icon
                              class="icon-order-shipment-box pill--icon"
                              size={18}
                            />
                            Shipment {index + 1}
                          </div>
                          {orderStatus.orderNo !== shipment.orderNo && (
                            <Button
                              className="button action-link more"
                              onClick={() =>
                                this.trackOrder(shipment.orderNo, index)
                              }
                            >
                              TRACK
                            </Button>
                          )}
                        </div>
                      )}
                      <ul className="desktop-order-details--items--ul">
                        {shipment.orderItems.map(item => {
                          const {
                            isItemCancelled,
                            isItemReturned,
                            isItemRefunded,
                            isItemReplaced,
                            itemCancelledText,
                            itemReturnedText,
                            itemRefundedText,
                            itemReplacedText,
                          } = item;
                          const hasCrr =
                            isItemCancelled ||
                            isItemReplaced ||
                            isItemReturned ||
                            isItemRefunded;
                          return (
                            <li key={item.sku} className="order-items">
                              <div className="desktop-order-details--items--item justify-content--space-between">
                                <div className="li-marker" />
                                <div className="flex-grow-1">
                                  <div>{item.productName}</div>
                                  <div>{item.quantityType}</div>
                                </div>
                                <div className="flex-shrink-0">
                                  {item.onsale && item.salePrice > 0 && (
                                    <div>
                                      <span className="desktop-order-details--items--qty">{`Qty: ${item.quantity}`}</span>
                                      <span className="desktop-order-details--items--striked-price">
                                        &#8377;{item.retailPrice}
                                      </span>
                                      <span className="desktop-order-details--items--final-price">
                                        &#8377;{item.salePrice}
                                      </span>
                                    </div>
                                  )}
                                  {!item.onsale && (
                                    <React.Fragment>
                                      <span className="desktop-order-details--items--qty">{`Qty: ${item.quantity}`}</span>
                                      <span className="desktop-order-details--items--final-price">
                                        &#8377;{item.retailPrice}
                                      </span>
                                    </React.Fragment>
                                  )}
                                </div>
                              </div>
                              {hasCrr && (
                                <div className="desktop-order-details--items--crr-status">
                                  {isItemCancelled && itemCancelledText && (
                                    <div className="pill error-pill">
                                      <Icon
                                        class="icon-status-order-cancelled"
                                        size={15}
                                      />
                                      <span>{itemCancelledText}</span>
                                    </div>
                                  )}
                                  {isItemRefunded && itemRefundedText && (
                                    <div className="pill delivered-pill">
                                      <Icon
                                        class="icon-status-order-refunded"
                                        size={15}
                                      />
                                      <span>{itemRefundedText}</span>
                                    </div>
                                  )}
                                  {isItemReturned && itemReturnedText && (
                                    <div className="pill error-pill">
                                      <Icon
                                        class="icon-status-order-returned"
                                        size={15}
                                      />
                                      <span>{itemReturnedText}</span>
                                    </div>
                                  )}
                                  {isItemReplaced && itemReplacedText && (
                                    <div className="pill delivered-pill">
                                      {itemReplacedText}
                                    </div>
                                  )}
                                </div>
                              )}
                            </li>
                          );
                        })}
                      </ul>
                    </React.Fragment>
                  );
                })}
                {showMembershipDetails && (
                  <ul className="desktop-order-details--items--ul">
                    <li className="order-items">
                      <div className="desktop-order-details--membership-container">
                        <div className="li-marker desktop-order-details--membership-backgraound-color" />
                        <MembershipOrderItem
                          membershipDetails={membershipDetails}
                          containerStyle="desktop-order-details--membership-sub-container"
                        />
                      </div>
                    </li>
                  </ul>
                )}
              </div>
              <div className="desktop-order-details--summary-box">
                {summaryOrder.map((detail, index) => {
                  if (!detail.amount && detail.hideEmpty) return false;
                  return (
                    <div
                      className="desktop-order-details--summary-box--item"
                      style={{ color: detail.hexcolors }}
                      key={detail.key}
                    >
                      <div className="key">
                        {detail.prefixIconUrl && (
                          <Icon src={detail.prefixIconUrl} size={22} />
                        )}
                        <span>{detail.text}</span>
                        {index === summaryOrder.length - 1 &&
                          orderDetails?.orderPaymentTypeFullForm && (
                            <div className="desktop-order-details--summary-box--item--sub-text">
                              {orderDetails?.orderPaymentTypeFullForm}
                            </div>
                          )}
                      </div>
                      <div className="value">
                        {detail.key === 'deliveryCharges' && detail.amount === 0
                          ? 'FREE'
                          : `${
                              detail.showSign ? `${detail.showSign} ` : ''
                            }${RUPEE_SYMBOL}${detail.amount}`}
                      </div>
                    </div>
                  );
                })}
              </div>
              {refundAmountMsg && (
                <Messages type="error" message={refundAmountMsg} />
              )}
              {allowContactCCA && CCAContact && CCAContactText && (
                <a
                  className="desktop-order-details--call-cca--cta button button-ghost full-width"
                  href={`tel:${CCAContact}`}
                >
                  {CCAContactText}
                </a>
              )}
              {!allowContactCCA && CCAContactText && (
                <div className="desktop-order-details--call-cca">
                  {CCAContactText}
                </div>
              )}
            </div>
          </React.Fragment>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ accountsReducer, initialReducer }) => ({
  orderDetails: accountsReducer.orderDetails,
  orderStatus: accountsReducer.orderStatus,
  launchInfo: initialReducer.launchInfo,
  loading: accountsReducer.loading,
});
const mapDispatchToProps = {
  getOrderDetails,
  trackOrder,
  postReorder,
  getInvoice,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderDetails);
